// extracted by mini-css-extract-plugin
export default {"screen":"PageLoadingBar_screen__a6Uqj","topOnly":"PageLoadingBar_topOnly__z-X7k","bar":"PageLoadingBar_bar__AYWVc","loading":"PageLoadingBar_loading__TFePk"};